<template>
  <div class="card__roadmap js-roadmap">
    <LKRoadmapsFeedCardRoadmapUp
      :node="node"
      v-on="$listeners || {}"
    />

    <LKRoadmapsFeedToggleLine
      :active="node.isActive"
      :loading="node.loading"
      label="Показать направления"
      class="mod--directions"
      @click.native="onLoadChildren"
    />

    <LKToggleContainer
      :active="node.isActive"
      class="direction-wrapper"
    >
      <div v-if="isAdresat" class="add__container">
        <LKRoadmapsFeedButtonAdd
          @click.native="$emit('add-direction', node)"
        />
      </div>

      <CardDirection
        v-for="(item, index) in node.children"
        :key="item.data.id"
        :node="item"
        :load-children="loadChildren"
        :class="{
          'mod--last': index === node.children.length - 1,
        }"
        v-on="$listeners || {}"
      />

      <div
        v-if="!node.children.length"
        class="text-md"
        v-text="'Список пуст'"
      />
    </LKToggleContainer>
  </div>
</template>

<script>
import { loadChildrenMixin } from '../mixins'

import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import CardDirection from '../CardDirection/LKRoadmapsFeedCardDirection.vue'
import LKRoadmapsFeedToggleLine from '../ui/LKRoadmapsFeedToggleLine.vue'
import LKRoadmapsFeedButtonAdd from '../ui/LKRoadmapsFeedButtonAdd.vue'
import LKRoadmapsFeedCardRoadmapUp from './LKRoadmapsFeedCardRoadmapUp.vue'


export default {
  name: 'LKRoadmapsFeedCardRoadmap',
  inject: [
    'isAdresat',
    'isCurator',
    'isCoordinator',
  ],
  components: {
    LKToggleContainer,
    CardDirection,
    LKRoadmapsFeedToggleLine,
    LKRoadmapsFeedButtonAdd,
    LKRoadmapsFeedCardRoadmapUp,
  },
  mixins: [
    loadChildrenMixin,
  ],
  inheritAttrs: false,
}
</script>
